<template>
    <div class="d-flex justify-content-center">
        <div>
        <div>Username : <input v-model="user" type="text" class="form-control"></div>
        <div class="mt-1">Password : <input v-model="pass" type="text" class="form-control"></div>
        <div class="mt-1"><button @click="login()" class="btn btn-success">Login</button></div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
         user : '',
         pass : '',
        }
    },
    methods:{
        login(){
            let username = this.user
            let password = this.pass
            this.$store
              .dispatch("login", { username, password }  )
              .then(() => this.$router.push("/addWord"))
              .catch(err => console.log(err));
        }
    }
}
</script>